import * as React from "react";
import Header from "../components/home/Header";
import Layout from "../components/common/Layout";
import HeroSection from "../components/home/HeroSection";
import KeyFeatures from "../components/home/KeyFeatures";
import CombinationSection from "../components/home/CombinationSection";
import CustomizationSection from "../components/home/CustomizationSection";
import Pricing from "../components/home/Pricing";
import Footer from "../components/home/Footer";

const IndexPage = () => {
  return (
    <Layout>
      <Header />
      <HeroSection />
      <KeyFeatures />
      <CombinationSection />
      <CustomizationSection />
      <Pricing />
      <Footer />
    </Layout>
  );
};

export default IndexPage;
